import { FC, useEffect, useState } from 'react';
import { Checkbox } from './checkbox';
import { CheckboxListProps, TCheckbox } from '../types';
import { Flex } from 'shared/ui/flex';

export const CheckboxList: FC<CheckboxListProps> = ({
	checkboxes,
	changeCheckbox,
	changeCheckboxes,
	defaultValue,
	multi = false,
	flexSetting = { direction: 'column', gap: 'initial' },
}) => {
	const [currentCheckbox, setSelectedCheckbox] = useState<TCheckbox | null>(
		null,
	);

	const [currentCheckboxes, setSelectedCheckboxes] = useState<
		TCheckbox[] | []
	>([]);

	const handleChangeCheckbox = (checkbox: TCheckbox, isChecked: boolean) => {
		if (multi) {
			if (!isChecked) {
				const checkboxes = currentCheckboxes.filter(
					prev => prev.id !== checkbox.id,
				);
				setSelectedCheckboxes(checkboxes);
				changeCheckboxes?.(checkboxes);
			} else {
				if (!currentCheckboxes.includes(checkbox as never)) {
					setSelectedCheckboxes([...currentCheckboxes, checkbox]);
					changeCheckboxes?.([...currentCheckboxes, checkbox]);
				}
			}
		} else {
			if (isChecked) {
				setSelectedCheckbox(checkbox);
				changeCheckbox?.(checkbox);
			} else {
				setSelectedCheckbox(null);
				changeCheckbox?.(null);
			}
		}
	};

	useEffect(() => {
		if (defaultValue) {
			if (multi) {
				setSelectedCheckboxes(defaultValue as TCheckbox[]);
			} else {
				setSelectedCheckbox(defaultValue as TCheckbox);
			}
		} else {
			setSelectedCheckbox(null);
		}
	}, [defaultValue, multi]);

	return (
		<Flex $direction={flexSetting.direction} $gap={flexSetting.gap}>
			{checkboxes.map(checkbox => {
				return (
					<Checkbox
						key={checkbox.id}
						onChange={isChecked => {
							handleChangeCheckbox(checkbox, isChecked);
						}}
						isChecked={
							multi
								? currentCheckboxes.some(
										currentCheckbox =>
											currentCheckbox.id === checkbox.id,
								  )
								: currentCheckbox?.id === checkbox.id
						}
					>
						{checkbox.name}
					</Checkbox>
				);
			})}
		</Flex>
	);
};
